import { Box, createTheme, ThemeProvider } from "@mui/material";
import { FC, useState } from "react";
import { themeSettings } from "../../../shared/theme/theme";
import { TAuthenticationSteps, IBlurMethod } from "../model/types/types";
import { SignInConfirm } from "./SignInConfirm";
import { SignInForm } from "./SignInForm";

export const SignInWrapper: FC<IBlurMethod> = ({ handleFocus }) => {
  const [step, setStep] = useState<TAuthenticationSteps>(1);
  const handleNextStep = (step: TAuthenticationSteps) => {
    setStep(step);
  };

  return (
    <ThemeProvider
      theme={createTheme({
        ...themeSettings,
        palette: {
          mode: "dark",
        },
      })}
    >
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          height: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        {step === 1 ? (
          <SignInForm
            handleNextStep={handleNextStep}
            handleFocus={handleFocus}
          />
        ) : (
          <SignInConfirm handleFocus={handleFocus} />
        )}
      </Box>
    </ThemeProvider>
  );
};
